module.exports = __webpack_public_path__ + "assets/img/图片二.19be658f.png";